import { cn } from "@/lib/utils";

export function SpecialAccountBU({
  label,
  subLabel,
  className,
}: {
  label: string;
  subLabel?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex items-center justify-start rounded h-10 p-1",
        className,
      )}
    >
      <div className="flex flex-col overflow-hidden px-1">
        <span className="text-ellipsis overflow-hidden font-medium">
          {label}
        </span>
        <span className="text-gray-500 text-xs text-left text-ellipsis overflow-hidden">
          {subLabel}
        </span>
      </div>
    </div>
  );
}
